export const getVersion = (isPrimary, type) => isPrimary && type !== 'underlined' ? 'primary' : 'secondary';
//# sourceMappingURL=getVersion.js.map